function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHourglass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 25,
    viewBox: "0 0 24 25",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M6.75 2.45A1.55 1.55 0 005.2 4v3.375a1.55 1.55 0 00.62 1.24l4.847 3.635-4.847 3.635a1.55 1.55 0 00-.62 1.24V20.5a1.55 1.55 0 001.55 1.55h10.5a1.55 1.55 0 001.55-1.55v-3.341a1.55 1.55 0 00-.615-1.237l-4.858-3.672 4.858-3.672A1.551 1.551 0 0018.8 7.34V4a1.55 1.55 0 00-1.55-1.55zm.05 4.9v-3.3h10.4v3.266l-5.202 3.933zm0 13.1v-3.3l5.198-3.899 5.202 3.932v3.267z",
    fill: props.fill,
    fillRule: "evenodd"
  }));
}

export default SvgHourglass;